
import { Button } from "@/components/ui/button";
import { Wallet, RefreshCcw } from "lucide-react";
import { cn } from "@/lib/utils";

interface WalletHeaderProps {
  isConnected: boolean;
  isRefreshing: boolean;
  onConnect: () => void;
  onRefresh: () => void;
}

export const WalletHeader = ({
  isConnected,
  isRefreshing,
  onConnect,
  onRefresh
}: WalletHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold bg-gradient-to-r from-emerald-600 to-blue-500 bg-clip-text text-transparent">Wallet</h1>
        <p className="text-gray-500 mt-1">Manage your crypto assets</p>
      </div>
      {!isConnected ? (
        <Button variant="success" onClick={onConnect} className="shadow-md hover:shadow-lg transition-all">
          <Wallet className="w-4 h-4 mr-2" />
          Connect Wallet
        </Button>
      ) : (
        <Button variant="outline" onClick={onRefresh} disabled={isRefreshing} className="border-emerald-200 hover:bg-emerald-50">
          <RefreshCcw className={cn("w-4 h-4 mr-2", isRefreshing && "animate-spin")} />
          Refresh
        </Button>
      )}
    </div>
  );
};
